import {h, Fragment} from "preact"
import { useAppState, HistoryElement, AutocompleteElement } from "@nosto/preact"
import { useEffect, useRef } from "preact/hooks"
import { defaultConfig, popularSearches } from "../config"
import { closeSearchOverlay } from "../helpers"

export default function History() {
    const { historyItems } = useAppState();
    const keywordsRef = useRef(null);

    useEffect(() => {
        if(window.nostojs){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ "nosto-dropdown-rec" ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    useEffect(() => {
        const handleClick = (event) => {
            if(event.target.closest('.ns-autocomplete-element')) {
                closeSearchOverlay()
            }
        }

        if(keywordsRef?.current) {
            keywordsRef.current.addEventListener('click', handleClick);
            return () => keywordsRef.current.removeEventListener('click', handleClick);
        }
    }, [])

    return (
        <div
            className="ns-autocomplete"
            data-nosto-element="autocomplete"
        >
            <div className="ns-autocomplete-inner">
                <div className="ns-autocomplete-results">
                    {popularSearches?.length > 0 && (
                        <div className="ns-autocomplete-section ns-autocomplete-keywords">
                            <h2 
                                id="ns-popular-searches-header" 
                                className="ns-autocomplete-section__header"
                            >
                                Popular Searches
                            </h2>
                            <div 
                                className="ns-autocomplete-section__content" 
                                aria-labelledby="ns-popular-searches-header"
                                ref={keywordsRef}
                            >
                                {popularSearches?.slice(0, defaultConfig.historySize).map(item => {
                                    return item.url ? (
                                        <a key={item.text} href={item.url} class="ns-autocomplete-element">
                                            {item.text}
                                        </a>
                                    ) : (
                                        <HistoryElement key={item.text} query={{ query: item.text }}>
                                            {item.text}
                                        </HistoryElement>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                    <div id="nosto-dropdown-rec" className="nosto_element ns-autocomplete-section ns-autocomplete-products"></div>
                </div>
            </div>
        </div>               
    )
}
